<template>
    <div class="flex justify-center divide-x-2 mt-3">
        <div class="text-22 pl-4 cursor-pointer"
             :class="[active == 'condition' ? 'text-green-1' : 'text-a-gray-666666']"
             @click="clickTab('condition')">
             เงื่อนไข
        </div>
    </div>
    <div class="mt-6 mb-3 txt-content overflow-y-scroll text-20 text-a-gray-666666">
        <div v-show="active == 'condition'" v-html="conditionText"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    props: {
        serialModel: { type: Object, required: true },
    },
    data: function() {
        return {
            active: 'condition', // detail, condition

            detailText: null,
            conditionText: null,
        };
    },
    created: function() {
        this.detailText = Util.newLineToBr(this.serialModel.detail);
        this.conditionText = Util.newLineToBr(this.serialModel.condition);
    },
    methods: {
        clickTab: function(active) {
            this.active = active;
        },
    }
}
</script>
<style lang="scss" scoped>
    .txt-content {
        max-height: 336px;
    }
</style>
